// Initial Overlay copy definitions

const initialOverlayCopy = {
  enterText: 'We envision worlds where emotions take shape.',
  ctaButton: {
    label: 'Reawaken Your Gaming Passion',
    ariaLabel: 'Begin your journey with Quintessence Games'
  }
};

export default initialOverlayCopy;
